import React from 'react';
import './Errors.css';
import { Button } from '../../component/form/Button';
import { useNavigate } from 'react-router-dom';

const Forbidden403: React.FC = () => {

    const nav = useNavigate();

    return (
        <div className="error-container">
            <h1 className="error-title">403 - Accesso Negato</h1>
            <p className="error-message">
                Spiacente, non hai i permessi necessari per accedere a questa pagina.
            </p>
            <Button name='Torna alla Home' action={() => nav('/') } />
        </div>
    );
};

export default Forbidden403;
